import React from 'react';
import useWebGLConfig from '../../hooks/useWebGLConfig';
import WebGLBackground from '../WebGLBackground';

/**
 * PageWrapper - Wrapper component that conditionally adds WebGL background
 * @param {string} pageName - Page identifier for WebGL config (e.g., 'projects', 'home')
 * @param {boolean} enableParticles - Override to force enable/disable particles
 * @param {object} particleConfig - Custom particle configuration
 * @param {React.ReactNode} children - Page content
 */
const PageWrapper = ({ 
  pageName, 
  enableParticles, 
  particleConfig = {},
  children 
}) => {
  const webglConfig = useWebGLConfig(pageName);
  
  // Override config if enableParticles prop is provided
  const shouldShowParticles = enableParticles !== undefined 
    ? enableParticles 
    : webglConfig.enabled;
  
  const finalConfig = {
    ...webglConfig,
    ...particleConfig,
    enabled: shouldShowParticles
  };

  return (
    <>
      {/* WebGL Background */}
      {shouldShowParticles && <WebGLBackground {...finalConfig} />}
      
      {/* Page Content */}
      {children}
    </>
  );
};

export default PageWrapper;